"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/Sections/Finish/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _useStatefulPromise = require('shared/hooks/useStatefulPromise');
var _Form = require('web/components/Form');
var _AuthFrame = require('web/components/AuthFrame');
var _components = require('web/screens/Signup/components');
var _amplitude = require('web/services/amplitude'); var _amplitude2 = _interopRequireDefault(_amplitude);



var _onboardingAnalytics = require('web/services/onboardingAnalytics');


var _SecondaryDownloads = require('./components/SecondaryDownloads'); var _SecondaryDownloads2 = _interopRequireDefault(_SecondaryDownloads);







const FinishSection = ({ onFinish, error }) => {
  const hasTrackedPromptView = _react.useRef.call(void 0, false)
  const { isLoading, run: handleSkip } = _useStatefulPromise.useStatefulPromise.call(void 0, onFinish)
  const platform = _react.useMemo.call(void 0, () => _SecondaryDownloads.computePlatformInfo.call(void 0, ), [])

  _react.useEffect.call(void 0, () => {
    if (isLoading || hasTrackedPromptView.current) return
    hasTrackedPromptView.current = true
    _onboardingAnalytics.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.APP_DOWNLOAD_PROMPT_VIEWED, {
      app_mode: platform.appMode,
      platform: 'web',
      surface: 'signup_finish',
    })
  }, [isLoading, platform.appMode])

  const handleSkipClick = () => {
    _amplitude2.default.logEvent('SIGN_UP_DOWNLOAD_SKIPPED', {
      surface: 'signup_finish',
      app_mode: platform.appMode,
      is_electron: platform.isElectron,
      is_mobile_browser: platform.isMobileBrowser,
    })
    // onFinish re-throws on login failure (the step shows the error inline);
    // the download screen stays put, so swallow to avoid an unhandled rejection.
    handleSkip().catch(() => { /* shown inline via the step error */ })
  }

  if (isLoading) return _react2.default.createElement(_components.SignupStepLoader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 49}} )

  const subtitle = platform.isMobileBrowser
    ? 'Open BloomText on your phone to get started.'
    : (platform.isElectron || !platform.hasDesktopInstaller)
        ? 'Get BloomText on your phone too.'
        : 'Download BloomText for the best experience.'

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_components.SignupStepHeader, { iconType: "ok", title: "You're all set!"  , subtitle: subtitle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}} )
      , _react2.default.createElement(_SecondaryDownloads2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} )
      ,  error && _react2.default.createElement(_AuthFrame.Callout, { message: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}} ) 
       /* On a phone the app is the primary way in; the browser is the
           fallback, so it steps down to a tonal button. */ 
      , _react2.default.createElement(_Form.Button, {
        isInverted: platform.isMobileBrowser,
        onClick: handleSkipClick,
        className: "signup-finish--continue", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}

        ,  platform.isMobileBrowser ? 'Continue in the browser' : 'Continue to BloomText' 
      )
    )
  )
}

exports. default = FinishSection
